import PropTypes from "prop-types";
import React from "react";
import { Form } from "react-bootstrap";

export const CheckBoxApp = (props) => {
    const {
        name = "",
        label,
        infoText = "",
        errorText = "",
        style = {},
        onChange = () => {},
        checked = false,
        required = false,
        labelClassName = ""
    } = props;

    let inputProps = { ...props };

    delete inputProps.checked;
    delete inputProps.onChange;
    delete inputProps.infoText;
    delete inputProps.errorText;
    // delete inputProps.required;

    const onCheckChange = (e) => {
        onChange({
            target: {
                name: e.target.name,
                value: e.target.checked,
            },
        });
    };

    // console.log({ name, required,inputProps });

    return (
        <Form.Group controlId={name}>
            <Form.Check
                {...inputProps}
                style={style}
                id={`id-input-${name}`}
                checked={Boolean(checked)}
                onChange={onCheckChange}
                required={required}
                label={
                    <span className={labelClassName}>
                        {label}
                        {required ? " (*)" : ""}
                    </span>
                }
            />
            <Form.Text className={`text-error`}>{errorText}</Form.Text>
            <Form.Text className={`text-muted`}>{infoText}</Form.Text>
        </Form.Group>
    );
};

CheckBoxApp.propTypes = {
    infoText: PropTypes.string,
    errorText: PropTypes.string,
    label: PropTypes.any,
    name: PropTypes.string,
    // checked: PropTypes.number,
    onChange: PropTypes.func,
};
